import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { isOverflowingBottom, isScrolledToBottom } from '../../../directives';

const getLabels = () => ({
  dialogTitle: 'Porting Report',
  successDescription: 'Plant Ported Successfully',
  failedDescription: 'Plant Failed to Port',
  portingFailureDescription: 'The not promoted plants contains devices that are in already promoted plants',
  closeButton: 'Understood',
});

@Component({
  selector: 'lib-porting-report-dialog',
  templateUrl: './porting-report-dialog.html',
  styleUrls: ['./porting-report-dialog.scss'],
})
export class SystemsPortingReportDialogComponent {
  plantPorted: string[];
  plantFailed: string[];
  labels: ReturnType<typeof getLabels>;

  isOverflowingBottom = isOverflowingBottom;
  isScrolledToBottom = isScrolledToBottom;

  constructor(
    readonly dialogRef: MatDialogRef<SystemsPortingReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { plantPorted: string[]; plantFailed: string[], label: ReturnType<typeof getLabels> }
  ) {
    this.plantPorted = data.plantPorted;
    this.plantFailed = data.plantFailed;
    this.labels = { ...getLabels(), ...data.label };
  }

  closeDialog() {
    this.dialogRef.close();
  }
}